export default {
	color: {
		default: '#e4e4e4',
		primary: '#b13c56',
		secondary: '#081D29',

		white: '#ffffff',
		black: '#000000',

		blue: '#39cccc',
		lightBlue: '#e4f2f4',
		yellow: '#fcb146',
		orange: '#f79905',

		success: '#1ece8e',
		warning: '#ffc107',
		danger: '#e7302a',

		graySuperlight: '#e4e4e4',
		grayDlight: '#dddddd',
		grayLight: '#cccccc',
		grayMedium: '#868F94',
		grayDark: '#333333',

		cartBg: '#fafdff',

		greenLight: '#11C35E',
		brown: '#563a22',
		fidilio: '#770C0C',
		facebook: '#3b5998',
		instagram: '#92643A',
		googleplus: '#d34836',
		linkedin: '#007bb6',
		twitter: '#1da1f2',
		telegram: '#2ca5e0',
		foursquare: '#F94877',
		bgGray: '#f8f8f8',

		border: '#e4e4e4',
		bgColor: '#ffffff',
		fgColor: '#ffffff',
		boxColor: '#ffffff',
		textColor: '#333333',
		linkColor: '#b13c56',
		dotBackground: '#cccccc',
		dotBackgroundActive: '#ef4123',

		placeholder: '#ebebeb',
		placeholderShine: '#d9d9d9',

		bgBlue: '#f5f8fb',
	},

	fontSize: {
		base: 16,
		xxSmall: 10,
		xSmall: 11,
		small: 12,
		normal: 14,
		large: 16,
		xLarge: 36,
		xxLarge: 80,
	},

	fontFamily: {
		primary: '"IRANSans", Tahoma, sans-serif',
	},

	device: {
		sm: 540,
		md: 720,
		lg: 960,
		xl: 1140,
		xxl: 1400,
	},

	button: {
		radius: 10,
	},

	box: {
		radius: 15,
	},

	transition: {
		all: 'all .4s cubic-bezier(0.19, 1, 0.22, 1)',
		function: 'cubic-bezier(0.19, 1, 0.22, 1)',
		normal: 'all .4s cubic-bezier(0.19, 1, 0.22, 1)',
		custom: 'cubic-bezier(0.19, 1, 0.22, 1)',
	},
};
